import React from "react";
import { AuthInfo, IFocusSDK } from "@/utils";
import Gateway from "@/server/gateway";
import { TFunction } from "i18next";
import { GlobalErrorConfig } from "@/utils/GError";
import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import Service from "@/services";
import { AuthData, RegistryConfigData } from "@/types/LocalConfig";
import ImService from "@/server/ImService";
import Eventemitter3 from "eventemitter3";
import { IClientConfig, IPermissions } from "../types/common";
import { UserCardData } from "@/types/UserCard";
import { Employee } from "@/types/chat";
import { ICommonConfig } from "@/models/user";

export interface GlobalContextConfig {
  t: TFunction;
  authInfo: AuthData;
  setAuthInfo: React.Dispatch<React.SetStateAction<AuthData | null>>;
  appRuntimeEnv: AppRuntimeEnv;
  localConfigData: RegistryConfigData;
  gatewayInstance: Gateway;
  service: Service;
  focusSDK: IFocusSDK;
  imService: ImService;
  isDesktop: boolean;
  onGlobalError: (config: GlobalErrorConfig) => void;
  onReLogin: (d: AuthData) => void;
  events3: Eventemitter3;
  permissions: IPermissions[];
  currentEmployee: Employee;
  notifyStatus?: any;
  notifyDis?: boolean;
  isWebpSupported?: boolean;
  globalDataInitFlag?: {
    permissions: false;
    quickReplys: false;
  };
  setPermissions?: any;
  setGlobalDataInitFlag?: any;
  onLine: boolean;
  clientConfig?: IClientConfig;
  isHomePage?: boolean;
  waterMarkText?: any;
  hiddenWaterMarkText?: any;
  commonConfig?: any;
  teamConfig?: any;
}
// @ts-ignore
const GlobalContext = React.createContext<GlobalContextConfig>({});

export default GlobalContext;
